module.exports = "https://cdn2-fs.clearscore.com/flux/images/37c02516c34c642b25282c93d94d1020.jpg";